import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-pdf-file-svg',
  templateUrl: './pdf-file-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class PdfFileSvgComponent {}
